module.exports = __webpack_public_path__ + "static/media/Neon_Main.ee949b8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Neon_Main.jpg
// module id = 177
// module chunks = 0